// @flow

import appConfig from 'config/app.config';
import { Licenses } from 'types/common';

import { RootUrl } from '../../config/paths';
import { register } from '../../i18n/l10n';
import { GET_CONTENT, GET_CONTENT_DONE } from '../actions';
import type { ContentActions, ContentState } from '../types';

const getInitialContentsByLicense = () => {
  const cguContent = {
    key: 'cgu',
    name: '',
    url: `${RootUrl}/cgu/cgu.php?lang={lang}&licence={licence}`,
    content: {},
    loading: false,
    tag: 'cgu',
  };

  const bettingRulesContent = {
    key: 'reglement-paris',
    name: '',
    url: `${RootUrl}/cgu/cgu-betting.php?lang={lang}&licence={licence}`,
    content: {},
    loading: false,
    tag: 'cgu',
  };

  const pokerRulesContent = {
    key: 'reglement-poker',
    name: '',
    url: `${RootUrl}/cgu/cgu-poker.php?lang={lang}&licence={licence}`,
    content: {},
    loading: false,
    tag: 'cgu',
  };

  const privacyContent = {
    key: 'confidentialite',
    name: '',
    url: `${RootUrl}/cgu/privacy.php?lang={lang}&licence={licence}`,
    content: {},
    loading: false,
    tag: 'cgu',
  };

  const promotionsBetting = {
    key: 'promotions-betting',
    name: '',
    url: `${RootUrl}/promotions/promotions_list.php?type=betting`,
    content: {},
    loading: false,
    tag: 'promotion',
  };

  const promotionsPoker = {
    key: 'promotions-poker',
    name: '',
    url: `${RootUrl}/promotions/promotions_list.php?type=poker`,
    content: {},
    loading: false,
    tag: 'promotion',
  };

  switch (appConfig.license) {
    case Licenses.DE:
      return [cguContent, bettingRulesContent, privacyContent];
    case Licenses.FR:
    case Licenses.ES:
    case Licenses.PT:
    default:
      return [cguContent, bettingRulesContent, pokerRulesContent, privacyContent, promotionsBetting, promotionsPoker];
  }
};

export const initialState: ContentState = {
  contents: getInitialContentsByLicense(),
};

export const contentReducer = (
  state: ContentState = initialState,
  action: ContentActions,
): ContentState => {
  switch (action.type) {
    case GET_CONTENT:
      return {
        ...state,
        contents: state.contents.map((content) => {
          if (content.key !== action.payload) {
            return content;
          }

          return {
            ...content,
            loading: true,
          };
        }),
      };

    case GET_CONTENT_DONE:
      return {
        ...state,
        contents: state.contents.map((content) => {
          if (content.key !== action.payload.key) {
            return content;
          }

          const { lang, content: newContent } = action.payload;

          return {
            ...content,
            content: {
              ...content.content,
              [lang]: newContent,
            },
            loading: false,
          };
        }),
      };

    default:
      return state;
  }
};

register(() => {
  initialState.contents.map((item: object) => {
    switch (item.key) {
      case 'cgu':
      // __('General Terms and Conditions')
        item.name = 'General Terms and Conditions';
        break;
      case 'reglement-paris':
      // __('Sports betting Terms and Conditions')
        item.name = 'Sports betting Terms and Conditions';
        break;
      case 'reglement-poker':
      // __('Poker Terms and Conditions')
        item.name = 'Poker Terms and Conditions';
        break;
      case 'confidentialite':
      // __('Privacy Policy')
        item.name = 'Privacy Policy';
        break;
      case 'promotions-betting':
        item.name = 'Betting Promotions';
        break;
      case 'promotions-poker':
        item.name = 'Poker Promotions';
        break;
      default:
        break;
    }

    return item;
  });
});
